var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00065 3.50377C10.8416 3.50377 12.334 4.99617 12.334 6.83708C12.334 8.67808 10.8416 10.1704 9.00065 10.1704C7.15967 10.1704 5.66729 8.67808 5.66729 6.83708C5.66729 4.99617 7.15967 3.50377 9.00065 3.50377ZM9.00065 4.75375C7.85006 4.75375 6.91729 5.6865 6.91729 6.83708C6.91729 7.98767 7.85006 8.92042 9.00065 8.92042C10.1512 8.92042 11.084 7.98767 11.084 6.83708C11.084 5.6865 10.1512 4.75375 9.00065 4.75375ZM9.00065 0.583252C12.8452 0.583252 16.1641 3.20826 17.0849 6.88692C17.1687 7.22175 16.9652 7.56117 16.6304 7.645C16.2955 7.72875 15.9561 7.52534 15.8723 7.19042C15.0899 4.06489 12.2684 1.83325 9.00065 1.83325C5.7314 1.83325 2.90904 4.0668 2.128 7.19425C2.04437 7.52909 1.70509 7.73275 1.3702 7.64917C1.0353 7.5655 0.831622 7.22625 0.915255 6.89134C1.8345 3.21052 5.15436 0.583252 9.00065 0.583252Z",
    fill: "#888B8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.2780ae7ac622ef2453e38cd1d9e38176.svg";
export { ForwardRef as ReactComponent };